import React, { Component } from 'react'
import { Button, Card, Col, Row } from 'reactstrap'
import { observer } from 'mobx-react'
import SelectFiltro from '../../../comum/components/SelectFiltro'
import { IconeCarregar } from '../../../comum/components/Icones'

@observer
export default class FiltroUnidadesLiberadasArmador extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }

    componentDidMount() {
        //
    }

    render() {
        return (
            <div className="filtro-card filtros-cabotagem">
                <Card className={`area-form pb-0`}>
                    <Row className="pb-0">
                        <SelectFiltro xs={12} sm={12} md={4} lg={4} xl={4}
                            bloqueado={this.controller.listaArmadores.length === 0}
                            titulo="Armador"
                            itens={this.controller.listaArmadores}
                            valor={this.controller.armadorSelecionado}
                            itensValor="value" itensLabel="label"
                            onChange={this.controller.setArmador}
                        />
                        { this.controller.loading && <IconeCarregar tamanho="2x" /> }
                        <Col className="col-botoes" xl={2} lg={3} md={4} sm={12} xs={12}>
                            <Button className="btn-com-bordas-primary btn-filtrar" onClick={this.controller.listarUnidadesArmadoresTipo} >Filtrar</Button>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/depot-unidades-liberadas/components/FiltroUnidadesLiberadasArmador.js